import { combineReducers } from 'redux'

import { createReducer } from 'helpers/ReducerUtil'
import {
  INIT_UI_RESTRICTED,
  TOGGLE_RESTRICTED,
  TOGGLE_UI_RESTRICTED,
  RESET_UI_RESTRICTED,
} from './constants'

const initUiRestricted = (values, action) => {
  return action.initValue
}

const toggleRestricted = (values, action) => {
  if (values[0].value === 'Yes') {
    return [{ value: 'No' }]
  }

  return [{ value: 'Yes' }]
}

const toggleUiRestricted = (values, action) => {
  if (values[0].value === 'Yes') {
    return [{ value: 'No' }]
  }

  return [{ value: 'Yes' }]
}

const resetUiRestricted = (values, action) => {
  return [{ values: 'No' }]
}

export const restrictedValueReducer = createReducer([{ value: 'No' }], {
  [TOGGLE_RESTRICTED]: toggleRestricted,
})

export const restrictedUiReducer = createReducer([{ value: 'No' }], {
  [INIT_UI_RESTRICTED]: initUiRestricted,
  [TOGGLE_UI_RESTRICTED]: toggleUiRestricted,
  [RESET_UI_RESTRICTED]: resetUiRestricted,
})

export const createUiReducer = (uiPath) => {
  return combineReducers({
    restricted: restrictedUiReducer,
  })
}
